export default "<router-outlet >\r\n    <spinner name=\"spinner\"></spinner>\r\n</router-outlet>";